export const onLogin = () => {
    var _a, _b;
    (_b = (_a = window.SN_CSM_EC) === null || _a === void 0 ? void 0 : _a.onLogin) === null || _b === void 0 ? void 0 : _b.call(_a);
};
export const onLogout = () => {
    var _a, _b;
    (_b = (_a = window.SN_CSM_EC) === null || _a === void 0 ? void 0 : _a.onLogout) === null || _b === void 0 ? void 0 : _b.call(_a);
};
//# sourceMappingURL=liveChat.js.map